export const TOP_SCORERS_LIST_REQUEST = "TOP_SCORERS_LIST_REQUEST";
export const TOP_SCORERS_LIST_SUCCESS = "TOP_SCORERS_LIST_SUCCESS";
export const TOP_SCORERS_LIST_FAIL = "TOP_SCORERS_LIST_FAIL";
